var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3h19.2v19.073H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13 5h-1.6v7.947H13V5zm3.864 1.724l-1.136 1.129a5.486 5.486 0 012.072 4.3c0 3.075-2.504 5.562-5.6 5.562-3.096 0-5.6-2.487-5.6-5.563 0-1.74.808-3.29 2.064-4.307l-1.128-1.12C5.984 8.034 5 9.974 5 12.151c0 3.95 3.224 7.152 7.2 7.152s7.2-3.202 7.2-7.152c0-2.177-.984-4.116-2.536-5.428z"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/log-out.svg";
export { SvgLogOut as ReactComponent };